import { OrderItem } from '../types/Order'
import { emptyGuid } from '../constants'
import { Product } from '../types/Product'
import { getTaxFactor } from './getTaxFactor'

export type NewOrderItem = {
  productId: string
  variantId: string
  quantity: number
  orderItemComment: string
  price: number
}

export function mapToOrderItem(productToAdd: NewOrderItem, productFromApi: Product, storeId?: string): OrderItem {
  const variant = productFromApi?.variants?.find((v: any) => v.id === (productToAdd.variantId || ''))
  const priceGross = productToAdd.price ?? (variant ? variant.price / 100 : productFromApi?.price / 100)
  const taxCode = productFromApi?.taxCode
  const taxFactor = getTaxFactor(taxCode)
  const vatSubTotalCalculated = priceGross * (1 - taxFactor)

  return {
    id: `${productToAdd.productId}-${Date.now()}`,
    productId: productToAdd.productId,
    publicId: '',
    type: 0,
    itemId: '',
    storeId: storeId || '',
    restaurantId: '',
    name: productFromApi?.name || productToAdd.productId,
    status: 0,
    price: priceGross,
    priceGross: priceGross,
    amount: productToAdd.quantity,
    weight: 0,
    subTotal: priceGross * productToAdd.quantity,
    vatSubTotal: vatSubTotalCalculated,
    imageUrl: productFromApi?.imageUrl || '',
    category: productFromApi?.categoryName || '',
    categoryId: productFromApi?.categoryId || null,
    description: productFromApi?.description || null,
    note: null,
    brandName: null,
    taxCode: productFromApi?.taxCode ?? null,
    vgr: null,
    ean: productFromApi?.ean || '',
    purchaseEan: null,
    gtin: null,
    reversalAmount: 0,
    uomCode: null,
    discountSubTotal: 0,
    discountVatSubTotal: 0,
    departmentNumber: null,
    departmentName: null,
    variantId: productToAdd.variantId || emptyGuid,
    variantName: variant?.name || '',
    message: productToAdd.orderItemComment || null,
    is20CodeBlock: false,
    customizationItems: [],
    quantity: productToAdd.quantity,
    ids: [{ id: emptyGuid, quantity: productToAdd.quantity }]
  }
}